import React from "react";
import { Link } from "react-router-dom";
import CartItems from "./CartItems";
import { useCart } from "../../context/CartContext";
import { Offcanvas } from "react-bootstrap";
import { ArrowUpRight } from "lucide-react";

function CartCanvas() {
  const { cartItems, cartSummary } = useCart();

  return (
    <>
      {/* Header Section */}
      <Offcanvas.Header className="flex items-center justify-between px-4 pt-4 pb-3 bg-[#fbf9f5] border-b border-[#ebdcca]">
        <div className="flex flex-col">
          <span className="font-serif italic text-lg text-[#b85d19] leading-none">
            Cart
          </span>
          <Offcanvas.Title className="font-serif text-2xl font-normal tracking-wide text-neutral-900 m-0">
          </Offcanvas.Title>
        </div>

        <button
          type="button"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          className="w-9 h-9 rounded-full border border-neutral-300 flex items-center justify-center text-neutral-700 hover:bg-neutral-100 transition-all duration-300 transform hover:rotate-90 shadow-sm"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-5 h-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </Offcanvas.Header>

      {/* Body Section */}
      <Offcanvas.Body className="p-0 bg-[#fbf9f5] flex flex-col h-full overflow-hidden">
        {cartItems && cartItems.length ? (
          <>
            {/* Scrollable Items Container */}
            <div className="flex-1 overflow-y-auto px-4 py-3 space-y-3 divide-y divide-[#ebdcca]/50">
              {cartItems.map((item, index) => (
                <div key={item._id || index} className="pt-3 first:pt-0">
                  <CartItems item={item} />
                </div>
              ))}
            </div>

            {/* Footer Section */}
            <div className="bg-[#fbf9f5] px-4 pt-3 pb-4 border-t border-[#ebdcca] mt-auto shadow-[0_-4px_20px_rgba(0,0,0,0.02)]">
              <div className="flex justify-between items-baseline mb-1">
                <span className="font-semibold text-[11px] tracking-widest text-neutral-600 uppercase">
                  Subtotal
                </span>

                <span className="font-serif text-[30px] font-medium text-[#b85d19]">
                  ₹{cartSummary.total}
                </span>
              </div>

             <Link
  to="/cart"
  style={{ textDecoration: "none" }}
  className="group relative overflow-hidden rounded-lg bg-[#d96810] hover:bg-[#b85d19] text-white
             py-2.5 px-4 sm:py-3.5 sm:px-5
             w-full flex items-center justify-between
             transition-all duration-500 shadow-md hover:shadow-xl
             transform hover:-translate-y-0.5"
>
  <span
    className="font-bold tracking-wide sm:tracking-widest
               text-[11px] sm:text-[13px]
               w-full text-center pl-4 sm:pl-5"
  >
    PROCEED TO CHECKOUT
  </span>

  <div
    className="w-7 h-7 sm:w-8 sm:h-8
               rounded-full border border-white/30
               flex items-center justify-center
               transition-all duration-300
               group-hover:rotate-45 group-hover:bg-white/10
               flex-shrink-0"
  >
    <ArrowUpRight className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-white" />
  </div>
</Link>

            </div>
          </>
        ) : (
          <div className="flex flex-col items-center justify-center h-full p-5 text-center animate-fade-in">
            <div className="emptycart font-serif text-base text-neutral-700 mb-2">
              <span>Your Shopping Cart is Empty</span>
            </div>

            <Link
              to="/shop"
              style={{ textDecoration: "none" }}
              className="mt-2 px-7 py-3 rounded-full bg-neutral-900 hover:bg-neutral-800 text-white font-medium text-sm transition-all duration-300 shadow-md hover:scale-105"
            >
              Shop Now
            </Link>
          </div>
        )}
      </Offcanvas.Body>
    </>
  );
}

export default CartCanvas;